export const normalizePlayer = (player = {}) => ({
  ...player,
  eligibility: player.eligibility ?? player.eligilibity,
  birthday: player.birthday ?? player.birth_date,
});

export const normalizeTeam = (team = {}) => ({
  ...team,
  team_name: team.team_name ?? team.name,
  players: Array.isArray(team.players) ? team.players.map(normalizePlayer) : [],
});

export const normalizeMatch = (match = {}) => ({
  ...match,
  home_team: match.home_team ?? match.home,
  away_team: match.away_team ?? match.away,
});
